'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactIntl = require('react-intl');

var _antd = require('@adparlor-devops/antd');

var _reactRouter = require('react-router');

var _escapeRegExp = require('lodash/string/escapeRegExp');

var _escapeRegExp2 = _interopRequireDefault(_escapeRegExp);

var _helpers = require('@adparlor-devops/js-anvil/helpers');

var _RulesetExpanded = require('./RulesetExpanded');

var _RulesetExpanded2 = _interopRequireDefault(_RulesetExpanded);

var _ValidationInput = require('./ValidationInput');

var _ValidationInput2 = _interopRequireDefault(_ValidationInput);

var _helpers2 = require('../../../../helpers/');

var _CreateRulesetForm = require('./CreateRulesetForm');

var _CreateRulesetForm2 = _interopRequireDefault(_CreateRulesetForm);

var _PriorityModal = require('./PriorityModal');

var _PriorityModal2 = _interopRequireDefault(_PriorityModal);

require('./Ruleset.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = _antd.Input.Search;
var RangePicker = _antd.DatePicker.RangePicker;


var messages = (0, _reactIntl.defineMessages)({
  searchTable: {
    'id': 'ruleset.search.placeholder',
    'defaultMessage': 'Search'
  }
});

var Ruleset = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Ruleset, _Component);

  function Ruleset(props) {
    (0, _classCallCheck3.default)(this, Ruleset);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Ruleset.__proto__ || (0, _getPrototypeOf2.default)(Ruleset)).call(this, props));

    _this.togglePriorityModal = function () {
      _this.setState({
        priorityModalVisible: !_this.state.priorityModalVisible
      });
    };

    _this.editRuleset = function (id) {
      var rulesetEditingIds = _this.state.rulesetEditingIds.map(function (editing) {
        return (0, _assign2.default)({}, editing);
      });
      rulesetEditingIds.push({ id: id });
      _this.setState({ rulesetEditingIds: rulesetEditingIds });
    };

    _this.hasValidationErrors = function (bool) {
      _this.setState({
        hasValidationErrors: bool
      });
    };

    _this.updateEditingRuleset = function (id, value, updatedAttribute) {
      var index = _this.state.rulesetEditingIds.findIndex(function (ruleset) {
        return ruleset.id === id;
      });
      var rulesetEditingIds = _this.state.rulesetEditingIds.map(function (ruleset) {
        return (0, _assign2.default)({}, ruleset);
      });
      var updatedProps = void 0;

      if (value === "name") updatedProps = { name: updatedAttribute };else if (value === "timezone") updatedProps = { timezone: updatedAttribute };else if (value === "schedule") {
        updatedProps = {
          startTime: updatedAttribute[0].format(),
          endTime: updatedAttribute[1].format()
        };
      }

      var rulesetEdit = (0, _assign2.default)({}, rulesetEditingIds[index], updatedProps);
      rulesetEditingIds.splice(index, 1, rulesetEdit);
      _this.setState({
        rulesetEditingIds: rulesetEditingIds
      });
      _this.hasValidationErrors(false);
    };

    _this.cancelEditRuleset = function (id) {
      var rulesetEditingIds = _this.state.rulesetEditingIds.map(function (editing) {
        return (0, _assign2.default)({}, editing);
      });
      var index = rulesetEditingIds.findIndex(function (ruleset) {
        return ruleset.id === id;
      });
      if (index !== -1) {
        // Record Found
        rulesetEditingIds.splice(index, 1);
        _this.setState({ rulesetEditingIds: rulesetEditingIds });
      }
    };

    _this.saveEditRuleset = function (record, updated) {
      var newRecord = (0, _assign2.default)({}, record);
      var newUpdated = (0, _assign2.default)({}, updated);
      delete newRecord.searchName;
      if (newUpdated.startTime && newUpdated.endTime) {
        newUpdated.startTime = (0, _helpers2.parseTimeInTimeZone)(newUpdated.startTime, record.timezone);
        newUpdated.endTime = (0, _helpers2.parseTimeInTimeZone)(newUpdated.endTime, record.timezone);
      }
      _this.props.rulesetsActions('update', { data: newRecord, updated: newUpdated, fetchRules: true });
      _this.cancelEditRuleset(newRecord.id);
    };

    _this.setRulesetSearchValue = function (event) {
      _this.setState({
        rulesetSearch: event.target.value
      });
    };

    _this.showCreateRulesetSlideout = function () {
      return _this.setState((0, _assign2.default)({}, _this.state, { createRuleset: { visible: true } }));
    };

    _this.hideCreateRulesetSlideout = function () {
      return _this.setState((0, _assign2.default)({}, _this.state, { createRuleset: { visible: false } }));
    };

    _this.formStateHasErrors = function (fieldsError) {
      return (0, _keys2.default)(fieldsError).some(function (field) {
        return fieldsError[field].errors;
      });
    };

    _this.getNextRulesetPriority = function () {
      var priorities = _this.props.ruleset.rulesetData.map(function (ruleset) {
        return ruleset.priority;
      });

      if (priorities.length > 0) {
        return Math.max.apply(Math, (0, _toConsumableArray3.default)(priorities)) + 1;
      }

      return 0;
    };

    _this.parseCreateRulesetPayload = function (unparsedPayload) {
      var payload = {};
      (0, _keys2.default)(unparsedPayload).forEach(function (field) {
        if (field === 'flightTime') {
          payload.startTime = (0, _helpers2.parseTimeInTimeZone)(unparsedPayload[field].value[0], unparsedPayload.timezone.value);
          payload.endTime = (0, _helpers2.parseTimeInTimeZone)(unparsedPayload[field].value[1], unparsedPayload.timezone.value);
        } else {
          payload[field] = unparsedPayload[field].value;
        }
      });
      return (0, _assign2.default)(payload, {
        advertiserId: _this.props.currentAdvertiser.id,
        platformId: 1
      });
    };

    _this.submitCreateRulesetForm = function () {
      var newState = (0, _assign2.default)({}, _this.state);
      newState.createRuleset.validateForm = true;
      _this.setState(newState, function () {
        /**
         *  Once the form has been validated, Ruleset has validation info and
         *  can process the payload to the store
        **/
        if (!this.formStateHasErrors(this.state.createRuleset.fields)) {
          var parsedPayload = this.parseCreateRulesetPayload(this.state.createRuleset.fields);
          this.props.rulesetsActions('create', parsedPayload);
        }
      });
    };

    _this.handleFormChange = function (changedFields) {
      var newState = (0, _assign2.default)({}, _this.state);
      newState.createRuleset.fields = (0, _assign2.default)({}, newState.createRuleset.fields, (0, _extends3.default)({}, changedFields));
      _this.setState(newState);
    };

    _this.rulesetExpanded = function (record) {
      return _react2.default.createElement(_RulesetExpanded2.default, {
        isPackage: _this.props.isPackage,
        record: record,
        savingRuleId: _this.props.ruleset.savingIds.rule,
        frequencies: _this.props.frequencies,
        rulesActions: _this.props.rulesActions,
        fetchingTimezones: _this.props.ruleset.fetchingTimezones,
        metaTimezones: _this.props.ruleset.meta.timezones
      });
    };

    _this.rulesetOnExpand = function (record) {
      if (typeof record.rulesData === 'undefined' && record.ruleCount !== 0) {
        _this.props.rulesActions('fetch', record);
      }
    };

    _this.onTableChange = function (pagination, filters, sorter) {
      _this.setState({
        sortedInfo: sorter
      });
    };

    _this.state = {
      rulesetEditingIds: [],
      rulesetSearch: '',
      createRuleset: {
        visible: false,
        fields: {
          name: {},
          status: {},
          timezone: {},
          flightTime: {},
          priority: {}
        },
        validateForm: false
      },
      priorityModalVisible: false,
      hasValidationErrors: false,
      sortedInfo: {
        columnKey: "priority",
        order: "ascend"
      }
    };
    return _this;
  }

  (0, _createClass3.default)(Ruleset, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.ruleset.rulesetErrorOccurred === false && this.props.ruleset.updatingRuleset !== nextProps.ruleset.updatingRuleset && !nextProps.ruleset.updatingRuleset) {
        if (this.state.priorityModalVisible) {
          // priority modal is opened and call was successful, close modal
          this.togglePriorityModal();
        }
      } else if (this.props.ruleset.rulesetErrorOccurred === false && this.props.ruleset.creatingRuleset !== nextProps.ruleset.creatingRuleset && !nextProps.ruleset.creatingRuleset) {
        this.hideCreateRulesetSlideout();
      }
    }

    /**
     *  Since there's no easy way for the form to return us the form (wholistic) validation status,
     *  we loop through our fields and see if there's an `error` property.
    **/


    /**
     *  Check the rulesets in the store and return the next priority ruleset in line.
    **/


    /**
     *  Process this.state.createRuleset fields to a normalized payload for our store
    **/


    /**
     *  CTA to handle the form submission of CreateRulesetForm
    **/


    /**
     *  Listen for all changes on the form fields and update the local state
    **/

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var sortedInfo = this.state.sortedInfo;


      var columns = [{
        title: ' ',
        dataIndex: 'delivery',
        key: 'delivery',
        width: 10,
        render: function render(text, record) {
          return (0, _helpers2.renderDeliveryTableCell)(record);
        }
      }, {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.name.column', defaultMessage: 'Rule Set Name' }),
        dataIndex: 'name',
        key: 'name',
        width: 150,
        className: 'rule-name',
        sorter: function sorter(rulesetOne, rulesetTwo) {
          var ruleSetNameOne = rulesetOne.name.toLowerCase();
          var ruleSetNameTwo = rulesetTwo.name.toLowerCase();
          if (ruleSetNameOne < ruleSetNameTwo) return -1;
          if (ruleSetNameOne > ruleSetNameTwo) return 1;
          return 0;
        },
        sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
        render: function render(name, record) {
          var isEditing = _this2.state.rulesetEditingIds.find(function (ruleset) {
            return ruleset.id === record.id;
          });
          if (isEditing) {
            return _react2.default.createElement(_ValidationInput2.default, {
              recordId: record.id,
              name: name,
              onChange: _this2.updateEditingRuleset,
              hasValidationErrors: _this2.hasValidationErrors
            });
          }
          if (_this2.state.rulesetSearch) {
            return _react2.default.createElement(
              'span',
              null,
              record.searchName
            );
          }
          return _react2.default.createElement(
            'span',
            null,
            name
          );
        }
      }, {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.publisher.column', defaultMessage: 'Publisher' }),
        dataIndex: 'platformId',
        key: 'platformId',
        width: 70,
        className: "text-align-center",
        render: function render(platformId) {
          return _react2.default.createElement('span', { className: 'icon-facebook-sign' });
        }
      }, {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.status.column', defaultMessage: 'Status' }),
        dataIndex: 'status',
        key: 'status',
        width: 80,
        className: "text-align-center",
        sorter: function sorter(rulesetOne, rulesetTwo) {
          if (rulesetOne.status < rulesetTwo.status) return -1;
          if (rulesetOne.status > rulesetTwo.status) return 1;
          return 0;
        },
        sortOrder: sortedInfo.columnKey === 'status' && sortedInfo.order,
        render: function render(status, record) {
          var isEditing = _this2.state.rulesetEditingIds.find(function (ruleset) {
            return ruleset.id === record.id;
          });
          return _react2.default.createElement(_antd.Switch, {
            size: 'small',
            checked: status === 'ACTIVE',
            disabled: typeof isEditing !== 'undefined',
            onChange: function onChange() {
              return _this2.saveEditRuleset(record, { status: record.status === 'ACTIVE' ? 'PAUSED' : 'ACTIVE' });
            }
          });
        }
      }, {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.ruleCount.column', defaultMessage: 'Rules' }),
        dataIndex: 'ruleCount',
        key: 'ruleCount',
        width: 60,
        className: "text-align-center",
        sorter: function sorter(rulesetOne, rulesetTwo) {
          return rulesetOne.ruleCount - rulesetTwo.ruleCount;
        },
        sortOrder: sortedInfo.columnKey === 'ruleCount' && sortedInfo.order
      }, {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.priority.column', defaultMessage: 'Priority' }),
        dataIndex: 'priority',
        key: 'priority',
        width: 70,
        className: "text-align-center",
        sorter: function sorter(rulesetOne, rulesetTwo) {
          return rulesetOne.priority - rulesetTwo.priority;
        },
        sortOrder: sortedInfo.columnKey === 'priority' && sortedInfo.order,
        render: function render(priority, record) {
          return _react2.default.createElement(_antd.Badge, { count: priority + 1, showZero: true });
        }
      }, {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.startTime-endTime.column', defaultMessage: 'Schedule' }),
        dataIndex: 'startTime-endTime',
        key: 'startTime-endTime',
        width: 175,
        sorter: function sorter(rulesetOne, rulesetTwo) {
          var dateOne = (0, _momentTimezone2.default)(rulesetOne.startTime);
          var dateTwo = (0, _momentTimezone2.default)(rulesetTwo.startTime);
          if (dateOne < dateTwo) return -1;
          if (dateOne > dateTwo) return 1;
          return 0;
        },
        sortOrder: sortedInfo.columnKey === 'startTime-endTime' && sortedInfo.order,
        render: function render(text, record) {
          var isEditing = _this2.state.rulesetEditingIds.find(function (ruleset) {
            return ruleset.id === record.id;
          });
          if (isEditing) {
            var currentDateTime = (0, _momentTimezone2.default)().tz(record.timezone);
            var startTime = _momentTimezone2.default.tz(record.startTime, record.timezone);
            var endTime = _momentTimezone2.default.tz(record.endTime, record.timezone);
            var disabledDate = function disabledDate(current) {
              return current && _momentTimezone2.default.tz(current, record.timezone).valueOf() < currentDateTime.startOf('day').valueOf();
            };
            var disabledTime = function disabledTime(selectedDates, type) {
              if (selectedDates && selectedDates.constructor === Array) {
                // If startDate and endDate is selected
                var _currentDateTime = (0, _momentTimezone2.default)().tz(record.timezone);
                var isStartDateEqualToEndDate = (0, _momentTimezone2.default)(selectedDates[0], record.timezone).format('M D YYYY') === (0, _momentTimezone2.default)(selectedDates[1], record.timezone).format('M D YYYY');
                if (type === 'start' || isStartDateEqualToEndDate) {
                  return {
                    disabledHours: function disabledHours() {
                      return _currentDateTime.hour() === 0 ? [] : [].concat((0, _toConsumableArray3.default)(Array(_currentDateTime.hour()).keys()));
                    },
                    disabledMinutes: function disabledMinutes() {
                      return _currentDateTime.minute() === 0 ? [] : [].concat((0, _toConsumableArray3.default)(Array(_currentDateTime.minute()).keys()));
                    },
                    disabledSeconds: function disabledSeconds() {
                      return [];
                    }
                  };
                }
              }
              return {
                disabledHours: function disabledHours() {
                  return [];
                },
                disabledMinutes: function disabledMinutes() {
                  return [];
                },
                disabledSeconds: function disabledSeconds() {
                  return [];
                }
              };
            };
            return _react2.default.createElement(RangePicker, {
              style: { width: 175 },
              defaultValue: [startTime, endTime],
              format: 'MMM-DD-YY',
              disabledDate: disabledDate,
              disabledTime: disabledTime,
              showTime: {
                defaultValue: [(0, _momentTimezone2.default)('00:00:00', 'HH:mm:ss'), (0, _momentTimezone2.default)('23:59:59', 'HH:mm:ss')]
              },
              onOk: function onOk(value) {
                return _this2.updateEditingRuleset(record.id, "schedule", value);
              }
            });
          }
          var formatter = (0, _helpers.scheduleFormatter)(record.startTime, record.endTime, record.timezone);
          var fullDateRange = (0, _helpers2.dateRangeFormater)(record.startTime, record.endTime, record.timezone);
          return _react2.default.createElement(
            _antd.Tooltip,
            { title: fullDateRange },
            _react2.default.createElement(
              'span',
              null,
              formatter
            )
          );
        }
      }, {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.timezone.column', defaultMessage: 'Timezone' }),
        dataIndex: 'timezone',
        key: 'timezone',
        width: 150,
        sorter: function sorter(rulesetOne, rulesetTwo) {
          if (rulesetOne.timezone < rulesetTwo.timezone) return -1;
          if (rulesetOne.timezone > rulesetTwo.timezone) return 1;
          return 0;
        },
        className: this.props.ruleset.fetchingTimezones ? "text-align-center" : "",
        sortOrder: sortedInfo.columnKey === 'timezone' && sortedInfo.order,
        render: function render(timezone, record) {
          // Editing a timezone is disabled until the backend is fixed. More information about this decision can be found at: https://adparlor.atlassian.net/browse/AD-5293 - bill
          // const isEditing = this.state.rulesetEditingIds.find((ruleset) => ruleset.id === record.id);
          // if (isEditing) {
          //   return (
          //     <div>
          //       <Select
          //         defaultValue={timezone}
          //         showSearch={true}
          //         style={{ width: 150 }}
          //         onChange={(value) => this.updateEditingRuleset(record.id, "timezone", value)}
          //         filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          //       >
          //         { this.props.timezones.map((timezone) => <Option key={timezone} value={timezone}>{timezone}</Option>)}
          //       </Select>
          //     </div>
          //   );
          // }
          if (_this2.props.ruleset.fetchingTimezones) {
            return _react2.default.createElement(_antd.Spin, { size: 'small' });
          }
          var metaTimezone = _this2.props.ruleset.meta.timezones.find(function (metaTimezone) {
            return timezone === metaTimezone.id;
          });
          return _react2.default.createElement(
            'span',
            null,
            metaTimezone ? metaTimezone.longLabel : timezone
          );
        }
      }, {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.lastEvaluatedAt.column', defaultMessage: 'Last Evaluated' }),
        dataIndex: 'lastEvaluatedAt',
        key: 'lastEvaluatedAt',
        width: 105,
        render: function render(text, record) {
          return (0, _helpers.lastExecutedAtFormatter)(record.lastEvaluatedAt, record.timezone);
        }
      }, {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.actions.column', defaultMessage: 'Actions' }),
        dataIndex: 'actions',
        key: 'actions',
        width: 90,
        className: "action-icons",
        render: function render(text, record) {
          var savingRulesetId = _this2.props.ruleset.savingIds.ruleset;
          if (savingRulesetId.includes(record.id)) {
            return _react2.default.createElement(_antd.Spin, null);
          }

          var isEditing = _this2.state.rulesetEditingIds.find(function (ruleset) {
            return ruleset.id === record.id;
          });
          if (isEditing) {
            var editableProps = ['name', 'timezone', 'endTime', 'startTime'];
            var shouldDisableSave = _this2.state.hasValidationErrors || !editableProps.some(function (prop) {
              return Object.prototype.hasOwnProperty.call(isEditing, prop);
            });
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: shouldDisableSave ? 'disable-cursor' : '' },
                _react2.default.createElement(
                  'a',
                  { disabled: shouldDisableSave, onClick: function onClick() {
                      return _this2.saveEditRuleset(record, isEditing);
                    } },
                  _react2.default.createElement(
                    _antd.Tooltip,
                    { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.actions.column.save.link', defaultMessage: 'Save' }) },
                    _react2.default.createElement(_antd.Icon, { type: 'check' })
                  )
                )
              ),
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'a',
                  { onClick: function onClick() {
                      return _this2.cancelEditRuleset(record.id);
                    } },
                  _react2.default.createElement(
                    _antd.Tooltip,
                    { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.actions.column.cancel.link', defaultMessage: 'Cancel' }) },
                    _react2.default.createElement(_antd.Icon, { type: 'close' })
                  )
                )
              )
            );
          }
          var deleteRulesetWithoutRulesMesssage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.actions.column.delete.popconfirm', defaultMessage: 'Are you sure you want to delete this Rule Set?' });
          var ruleMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'ruleset.table.actions.column.delete.multiple.rule.popconfirm',
            defaultMessage: 'Deleting this Rule Set will also delete {ruleCount, number} {ruleCount, plural, one {Rule} other {Rules}} contained within.',
            values: { ruleCount: record.ruleCount }
          });
          var rulesetDeleteMessage = record.ruleCount > 0 ? _react2.default.createElement(
            'span',
            null,
            ruleMessage,
            _react2.default.createElement('br', null),
            deleteRulesetWithoutRulesMesssage
          ) : deleteRulesetWithoutRulesMesssage;

          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'a',
                { onClick: function onClick() {
                    return _this2.editRuleset(record.id);
                  } },
                _react2.default.createElement(
                  _antd.Tooltip,
                  { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.actions.column.edit.link', defaultMessage: 'Edit Settings' }) },
                  _react2.default.createElement(_antd.Icon, { type: 'edit' })
                )
              )
            ),
            _react2.default.createElement(
              _antd.Popconfirm,
              {
                title: rulesetDeleteMessage,
                onConfirm: function onConfirm() {
                  return _this2.props.rulesetsActions('delete', record.id);
                }
              },
              _react2.default.createElement(
                'a',
                null,
                _react2.default.createElement(
                  _antd.Tooltip,
                  { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.table.actions.column.delete.link', defaultMessage: 'Delete' }) },
                  _react2.default.createElement(_antd.Icon, { type: 'delete' })
                )
              )
            )
          );
        }
      }];
      var dataSource = this.props.ruleset.rulesetData.map(function (ruleset) {
        return (0, _assign2.default)({}, ruleset);
      });
      var disableChoosePriorityButton = this.state.rulesetEditingIds.length !== 0 || this.state.rulesetSearch !== '';
      if (this.state.rulesetSearch) {
        var reg = new RegExp((0, _escapeRegExp2.default)(this.state.rulesetSearch), 'gi');
        dataSource = dataSource.map(function (record) {
          var match = record.name.match(reg);
          if (!match) {
            return null;
          }
          return (0, _extends3.default)({}, record, {
            searchName: _react2.default.createElement(
              'span',
              null,
              record.name.split(reg).map(function (text, i) {
                return i > 0 ? [_react2.default.createElement(
                  'span',
                  { className: 'highlight' },
                  match[0]
                ), text] : text;
              })
            )
          });
        }).filter(function (record) {
          return !!record;
        });
      }
      return _react2.default.createElement(
        'div',
        { className: 'ruleset__component' },
        _react2.default.createElement(
          'div',
          { className: 'advertiser-name' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'ruleset.advertiserName',
            defaultMessage: '{name} Rule Sets',
            values: { name: this.props.currentAdvertiser.name }
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'header-row' },
          _react2.default.createElement(
            _antd.Button,
            { type: 'primary', onClick: this.showCreateRulesetSlideout },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.newRuleSet', defaultMessage: 'New Rule Set' })
          ),
          _react2.default.createElement(
            _antd.Button,
            { onClick: this.togglePriorityModal, disabled: disableChoosePriorityButton },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.choosePriorities', defaultMessage: 'Choose Priorities' })
          ),
          _react2.default.createElement(
            _antd.Button,
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/advertisers/' + this.props.currentAdvertiser.id + '/activity' },
              _react2.default.createElement(_antd.Icon, { type: 'clock-circle-o' }),
              ' ',
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.viewActivityFeed.button', defaultMessage: 'View Activity Feed' })
            )
          ),
          _react2.default.createElement(Search, {
            placeholder: this.props.intl.formatMessage(messages.searchTable),
            style: { width: 150 },
            onChange: function onChange(e) {
              return _this2.setRulesetSearchValue(e);
            }
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'ruleset-table' },
          _react2.default.createElement(_antd.Table, {
            size: 'middle',
            rowKey: 'id',
            bordered: true,
            loading: this.props.ruleset.loadingRulesets,
            columns: columns,
            dataSource: dataSource,
            expandedRowRender: function expandedRowRender(record) {
              return _this2.rulesetExpanded(record);
            },
            onExpand: function onExpand(expanded, record) {
              return _this2.rulesetOnExpand(record);
            },
            onChange: this.onTableChange,
            pagination: {
              defaultPageSize: 15
            }
          })
        ),
        _react2.default.createElement(
          _antd.Slideout,
          {
            title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.slideout.newRuleSet.button', defaultMessage: 'New Rule Set' }),
            visible: this.state.createRuleset.visible,
            onCancel: this.hideCreateRulesetSlideout,
            header: [_react2.default.createElement(
              _antd.Button,
              {
                key: 'submit',
                type: 'primary',
                onClick: this.submitCreateRulesetForm,
                loading: this.props.ruleset.creatingRuleset
              },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleset.slideout.saveAndContinue.button', defaultMessage: 'Save and Continue' })
            )]
          },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_CreateRulesetForm2.default, (0, _extends3.default)({}, this.state.createRuleset.fields, {
              validate: this.state.createRuleset.validateForm,
              onChange: this.handleFormChange,
              fetchingTimezones: this.props.ruleset.fetchingTimezones,
              timezones: this.props.ruleset.meta.timezones,
              initialValues: {
                status: 'PAUSED',
                priority: this.getNextRulesetPriority()
              }
            }))
          )
        ),
        _react2.default.createElement(_PriorityModal2.default, {
          visible: this.state.priorityModalVisible,
          togglePriorityModal: this.togglePriorityModal,
          ruleset: this.props.ruleset,
          rulesetsActions: this.props.rulesetsActions
        })
      );
    }
  }]);
  return Ruleset;
}(_react.Component), _class.propTypes = {
  isPackage: _propTypes2.default.bool.isRequired,
  currentAdvertiser: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.number.isRequired
  }).isRequired,
  ruleset: _propTypes2.default.shape({
    rulesetData: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    fetchingTimezones: _propTypes2.default.bool,
    meta: _propTypes2.default.shape({
      timezones: _propTypes2.default.arrayOf(_propTypes2.default.object)
    }),
    rulesetErrorOccurred: _propTypes2.default.bool,
    updatingRuleset: _propTypes2.default.bool,
    loadingRulesets: _propTypes2.default.bool,
    creatingRuleset: _propTypes2.default.bool,
    savingIds: _propTypes2.default.shape({
      ruleset: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
      rule: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired
    }).isRequired
  }).isRequired,
  frequencies: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  rulesetsActions: _propTypes2.default.func.isRequired,
  rulesActions: _propTypes2.default.func.isRequired,
  intl: _reactIntl.intlShape.isRequired
}, _temp);
exports.default = (0, _reactIntl.injectIntl)(Ruleset);


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Ruleset/components/Ruleset.js
// module id = 3683
// module chunks = 3